export default {
    step: 1,
    currentComponent: "negociar-divida",
    dividas: [],
    acordo: {}
}